import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {TextUtils} from "../../../../../../shared/utils/text-utils";
import {ProductBackorderStatus, ProductStockStatus} from "../../../ecommerce-product.enum";
import {DbModalService} from "../../../../../../modules/modal/modal";
import {
  AddProductVariantsModalComponent
} from "../components/add-product-variants-modal/add-product-variants-modal.component";
import {IAttribute, IOption} from "../add-product-form.interface";

@Component({
    selector: 'db-product-inventory',
    templateUrl: './product-inventory.component.html',
    styleUrls: ['./product-inventory.component.scss'],
    standalone: false
})
export class ProductInventoryComponent implements OnInit {
  @Input() inventoryForm: FormGroup;
  @Input() variantsForm: FormGroup;
  @Input() activeAttributes: IOption[];
  @Input() attributes: IAttribute[];
  @Output() apply: EventEmitter<IOption[]> = new EventEmitter<IOption[]>();

  @Input() set hasAttributes(value) {
    if (!this.inventoryForm) {
      return;
    }
    this.disableFields = value;
    // const checkbox = this.inventoryForm?.get('track_quantity');
    // if (value) {
    //   checkbox.reset();
    // } else {
    //   checkbox.enable();
    // }
  }

  disableFields = false;
  statusOptions = [
    {
      value: ProductStockStatus.IN_STOCK,
      label: TextUtils.getText('text_inStock')
    },
    {
      value: ProductStockStatus.OUT_OF_STOCK,
      label: TextUtils.getText('text_outOfStock')
    },
    {
      value: ProductStockStatus.ON_BACKORDER,
      label: TextUtils.getText('text_onBackorder')
    },
  ];
  backorderStatusOptions = [
    {
      value: ProductBackorderStatus.DO_NOT_ALLOW,
      label: TextUtils.getText('text_doNotAllow')
    },
    {
      value: ProductBackorderStatus.ALLOW_NOTIFY,
      label: TextUtils.getText('text_allowButNotifyCustomer')
    },
    {
      value: ProductBackorderStatus.ALLOW,
      label: TextUtils.getText('text_allow')
    },
  ];

  get statusFormControl(): FormControl {
    return this.inventoryForm.get('stock_status') as FormControl;
  }

  get backorderStatusFormControl(): FormControl {
    return this.inventoryForm.get('backorder_status') as FormControl;
  }

  constructor(private modalService: DbModalService) {
  }

  ngOnInit() {
  }

  openAddOption() {
    const modal = this.modalService.open(AddProductVariantsModalComponent);
    modal.componentInstance.variantsForm = this.variantsForm;
    modal.componentInstance.activeAttributes = this.activeAttributes;
    modal.componentInstance.attributes = this.attributes;
    modal.componentInstance.apply = this.apply;
  }

}
